import React, { useState } from 'react'
import { FormGroup, FormControl, Form, Button } from "react-bootstrap";
import Select from 'react-select'


import "./AddListing.css"

const AddListing =()=>{
const [data,setData]=useState({
  listingTitle: '',
    password: '',
    category:'',
    days:"",
})
    console.log("addListing");
 function  handleChange(event) {
     setData({
      [event.target.name]: event.target.value
    });
    console.log(event.target.name);
    console.log(event.target.value);
  }

  
  function handleSubmit(event) {
    event.preventDefault();
    
  }


    return(
        <>
        <div className='d-flex align-items-center mb-5'>
        <div className='flex-1 container'>
          <div className="signInDiv margin-top-100">
            <p className='bold-font h4  themeColor2 text-center'>Add Listing</p>
            <p className='paraListing light-font '></p>

            <form className='' onSubmit={handleSubmit}>

            <span className='bold-semifont para mt-4 dib'>PRIMARY LISTING DETAILS</span>
            <div className='app-border-full'></div>
            <div className="form-group">
              <span className='bold-semifont paraListing'>Business Name*</span>
              <input className="form-control" placeholder="XYZ Fabric" name="listingTitle" type="text" onChange={(e)=>handleChange(e)} value={data.listingTitle}></input>
            </div>
          
            <div className="form-group">
              <span className='bold-semifont paraListing'>Keywords*</span>
              <input className="form-control" placeholder="Keyword should be separated by commas" name="keywords" type="text" onChange={(e)=>handleChange(e)} value={data.keywords}></input>
            </div>
            <div className="form-group">
              <span className='bold-semifont paraListing'>Full Address*</span>
              <input className="form-control" placeholder="Add address here" name="fullAddress" type="email" onChange={(e)=>handleChange(e)} value={data.fullAddress}></input>
            </div>
            <div className="form-group">
              <span className='bold-semifont paraListing'>City*</span>
              <input className="form-control" placeholder="Add address here" name="city" type="text" onChange={(e)=>handleChange(e)} value={data.city}></input>
            </div>
            <div className="form-group">
              <span className='bold-semifont paraListing'>Website</span>
              <input className="form-control" placeholder="Add address here" name="website" type="text" onChange={(e)=>handleChange(e)} value={data.website}></input>
            </div>

            <span className='bold-semifont para mt-5 dib'>CATEGORY & SERVICES</span>
            <div className='app-border-full'></div>

            <div className="form-group">
              <span className='bold-semifont paraListing'>Category</span>
              <select className="form-control" placeholder="Add Category here" onChange={(e)=>handleChange(e)} name="category" value={data.category} aria-label="Default select example">
                <option value="">Select Type</option>
                <option value="Restaurant">Restaurant</option>
                <option value="Shop">Shop</option>
                <option value="RealState">Real State</option>
              </select>
            </div>

          
            {/* Business hours */}
            <span className='bold-semifont para mt-5 dib'>BUSINESS HOURS</span>
            <div className='app-border-full'></div>
            {/* <div>
              <span>Facebook</span>
              <span>ahsaniqbal426</span>
              <span className="mb-3 col-auto"><i class="fa fa-plus addSocialLinkBtn"></i></span>
            </div> */}
            <div className="row ai-center">
              <div className="form-group col-auto">
                <select className="form-control" placeholder="Day" onChange={(e)=>handleChange(e)} name="days" value={data.days} aria-label="Default select example">
                  <option value="monday">Monday</option>
                  <option value="tuesday">Tuesday</option>
                  <option value="wednesday">Wednesday</option>
                  <option value="thursday">Thursday</option>
                  <option value="friday">Friday</option>
                  <option value="saturday">Saturday</option>
              

                  {/* <option value="friday">Saturday</option> */}
                </select>
              </div>
              <div className="form-group col-auto">
                <select className="form-control" placeholder="From" onChange={(e)=>handleChange(e)} name="days" value={data.days} aria-label="Default select example">
                  <option value="monday">08:00 AM</option>
                  <option value="monday">09:00 AM</option>
                  <option value="monday">10:00 AM</option>
                  <option value="monday">11:00 AM</option>
                  <option value="monday">12:00 pM</option>
                  <option value="monday">01:00 PM</option>
                </select>
              </div>
              <div className="form-group col-auto">
                <select className="form-control" placeholder="To" onChange={(e)=>handleChange(e)} name="days" value={data.days} aria-label="Default select example">
                  <option value="monday">05:00 PM</option>
                  <option value="monday">06:00 PM</option>
                  <option value="monday">07:00 PM</option>
                  <option value="monday">08:00 PM</option>
                  <option value="monday">09:00 PM</option>
                  <option value="monday">10:00 PM</option>
                </select>
              </div>
              
              <span className="mb-3 col d-flex jcE"><i className="fa fa-plus addSocialLinkBtn"></i></span>
            </div>
            {/* social media */}
            <span className='bold-semifont para mt-5 dib'>SOCIAL MEDIA</span>
            <div className='app-border-full'></div>
            {/* <div>
              <span>Facebook</span>
              <span>ahsaniqbal426</span>
              <span className="mb-3 col-auto"><i class="fa fa-plus addSocialLinkBtn"></i></span>
            </div> */}
            <div className="row ai-center">
              <div className="form-group col-auto">
                <select className="form-control" placeholder="Select Media" onChange={(e)=>handleChange(e)} name="socialMedia" value={data.socialMedia} aria-label="Default select example">
                  <option >Select Media</option>
                  <option value="Restaurant">Restaurant</option>
                  <option value="Shop">Face</option>
                  <option value="RealState">Real State</option>
                </select>
              </div>
              <div className="form-group col">
                <input className="form-control" placeholder="Social Media Link" name="mediaLink" type="text" onChange={(e)=>handleChange(e)} value={data.mediaLink}></input>
              </div>
              <span className="mb-3 col-auto"><i className="fa fa-plus addSocialLinkBtn"></i></span>
            </div>
            {/* description */}
            <span className='bold-semifont para mt-5 dib'>DESCRIPTION</span>
            <div className='app-border-full'></div>
            <div>
              <textarea className="form-control" placeholder="Description ..." name="description" onChange={(e)=>handleChange(e)} value={data.description} rows="4" cols="50">
              </textarea>
            </div>

             {/* Images */}
            <span className='bold-semifont para mt-5 dib'>IMAGES</span>
            <div className='app-border-full'></div>
            <div>
              <p className="mb-1">Cover image</p>
              <input type="file" placeholder="coverImage" />
              <p className="mb-1 mt-3">Business Logo</p>
              <input type="file" placeholder="coverImage" />
            </div>

             
           

            {/* <hr /> */}
            
            <div className="form-group text-center mt-4">
              <Button className='round-button' type="submit">Save</Button>
            </div>

          </form>
          </div>
        </div>
      </div>

        </>
    )
}
export default AddListing